export const shippingMethodLddProps = () => ({
  service: {
    type: Object,
    required: true
  },
  addresseLad: {
    type: Object,
    required: false
  },
  idAddressLivraison: {
    type: [Number, String],
    required: false,
    default: null
  }
})

export const shippingMethodLddEmits = () => ([
  "updateModeCommande"
])

export const useShippingMethodLdd = (context) => {
  const updateModeCommande = () => {
    context.emit("updateModeCommande")
  }
  return { updateModeCommande }
}